import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";

export default function Footer() {

  return (
    <footer className="bg-[#e8f0f8] dark:bg-[#0a1f3d] text-[#0e3a66] dark:text-white relative">
      {/* Wave top */}
      <div className="absolute top-0 left-0 w-full pointer-events-none -translate-y-full">
        <svg viewBox="0 0 1440 40" preserveAspectRatio="none" className="w-full" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,20 C360,40 1080,0 1440,20 L1440,40 L0,40 Z" fill="#e8f0f8" className="dark:fill-[#0a1f3d]"/>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Logo + Brand */}
          <div className="flex flex-col items-center sm:items-start gap-3">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="https://images.weserv.nl/?url=media.base44.com/images/public/6a2225f85d295b30c327a9d5/8e0730d41_waterslideshoustontx_com_WaterSlidesHoustonTexas100x100_29788ec0.png&w=56&output=webp&q=80"
                alt="Water Slides Houston Texas"
                width={56}
                height={56}
                loading="lazy"
                decoding="async"
                className="w-14 h-14 object-contain rounded-xl"
                onError={(e) => { e.target.style.display="none"; e.target.nextElementSibling.style.display="flex"; }}
              />
              <span className="hidden w-14 h-14 rounded-xl bg-primary items-center justify-center text-primary-foreground font-bold text-lg">WS</span>
            </Link>
            <p className="text-[#0e3a66]/80 dark:text-white/80 text-sm text-center sm:text-left max-w-xs">
              The best inflatable water slide rentals in Houston, Texas. Clean, safe, and fun for the whole family!
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center sm:items-start gap-2">
           <h4 className="font-bold text-[#0e3a66] dark:text-white text-sm uppercase tracking-wide mb-1">Quick Links</h4>
           <Link to="/" className="text-[#0e3a66]/80 dark:text-white/70 text-sm hover:text-primary transition-colors">Home</Link>
           <Link to="/water-slides-rentals" className="text-[#0e3a66]/80 dark:text-white/70 text-sm hover:text-primary transition-colors">Water Slides</Link>
           <Link to="/party-rentals" className="text-[#0e3a66]/80 dark:text-white/70 text-sm hover:text-primary transition-colors">Party Rentals</Link>
           <Link to="/service-area" className="text-[#0e3a66]/80 dark:text-white/70 text-sm hover:text-primary transition-colors">Service Area</Link>
           <Link to="/about-us" className="text-[#0e3a66]/80 dark:text-white/70 text-sm hover:text-primary transition-colors">About Us</Link>
           <Link to="/service-area" className="text-[#0e3a66]/80 dark:text-white/70 text-sm hover:text-primary transition-colors">Contact</Link>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center sm:items-start gap-2">
            <h4 className="font-bold text-[#0e3a66] dark:text-white text-sm uppercase tracking-wide mb-1">Contact Us</h4>
            <a href="tel:18329704583" className="flex items-center gap-2 text-[#0e3a66]/80 dark:text-white/70 text-sm hover:text-primary transition-colors">
              <Phone className="w-4 h-4 text-primary" /> 832 970 4583
            </a>
            <div className="flex items-center gap-2 text-[#0e3a66]/80 dark:text-white/70 text-sm">
              <MapPin className="w-4 h-4 text-primary flex-shrink-0" /> Houston, Texas
            </div>
            <a href="tel:18329704583" className="mt-2 bg-primary text-primary-foreground font-bold px-6 py-2 rounded-full text-sm hover:bg-primary/90 transition-all hover:scale-105">
              Book Now!
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#0e3a66]/10 dark:border-white/10 mt-8 pt-6 flex items-center justify-center">
          <p className="text-[#0e3a66]/80 dark:text-white/80 text-sm text-center">
            © 2026 Water Slides Houston Texas. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}